import {sector} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadSectors(additional: string) {
  return useLoad(sector, 'iD_Sector', {additional});
}

export default useLoadSectors;
